<v-last-viewed-clients-tabs></v-last-viewed-clients-tabs>


<div class="content_wrapper">
    <v-scrollable-menu v-model="activeTab" :items="tabs" @update:modelValue="clickOnTab"></v-scrollable-menu>


    <div :class="hasLastViewedClients ? 'mt-2 members_wrapper_with_last_viewed_clients' : 'mt-2 members_wrapper' ">
        <active v-if="isShowActiveChild"></active>
        <all v-if="isShowAllChild"></all>
        <inClub v-if="isShowInClubChild"></inClub>
        <new v-if="isShowNewChild"></new>
        <inDebt v-if="isShowInDebtChild"></inDebt>
        <endSoon v-if="isShowEndSoonChild"></endSoon>
        <former v-if="isShowFormerChild"></former>
        <corporate v-if="isShowCorporateChild"></corporate>
    </div>
</div>







